import Sumer from '@meterio/sumer-js'

const Vault_Url = 'https://api-sumer.sumer.money/api/infrared'
export const getInfraredVaultInfo = async (vaultAddr) => {
  const res = await fetch(`${Vault_Url}/vault/${vaultAddr}`)
  const jsonRes = await res.json()
  console.log('VaultInfo', jsonRes)
  return jsonRes.Result
}

export const getIBGTEarned = async (sumer, target, account) => {
  const options = {
    abi: Sumer.abi.CInfraredVault,
    _sumerProvider: sumer._provider,
  }

  const res = await Sumer.eth.read(target, 'earned', [account], options)
  const obj = res.map((r) => r.toObject())
  console.log('earned', obj)
  return obj
}
